// extracted by mini-css-extract-plugin
module.exports = {"labelStyle":"CreateNewButton_labelStyle__2gbd2","button":"CreateNewButton_button__1zHHb"};